module.exports = __webpack_public_path__ + "img/quexing-bg.36006480.png";